// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import TransportCard from '/react4xp/components/TransportCard'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface TransportCardsProps {
    line?: boolean
    title?: string
    cards: Array<{
        title?: string
        intro?: string
        link?: {
            href: string
            external?: boolean
        }
        cardColor: 'beige' | 'green'
    }>
}

export default function TransportCards({
    line,
    title,
    cards
}: TransportCardsProps) {
    return (
        <Section
            textColor='text-dark'
            className='transport-cards'
        >
            <div className='grid-container'>

                {line && (
                    <div className='transport-cards__line'></div>
                )}

                {isNonWhitespaceString(title) && (
                    <h2 className='transport-cards__title title-sm'>
                        {title}
                    </h2>
                )}

                {cards && cards.length > 0 && (
                    <div className='transport-cards__grid'>
                        {cards.map((item, i) => (
                            <TransportCard
                                key={i}
                                title={item.title}
                                intro={item.intro}
                                link={item.link}
                                cardColor={item.cardColor}
                            />
                        ))}
                    </div>    
                )}
                
            </div>
        </Section>
    )
}